import {AIProcessFile} from "@/utils/api.js";

export function m_processFileUploadAI(p_appEntKey, p_file){
	
let allSchema={extr: 
			`"contact":{"externalContactName":"string",
			            "company": "string",
						"role":"string",
						"address":"string",
						"phoneNo:"string",
						"mobilePhoneNo:"string",
						"officePhoneNo:"string",
						"email":"string",
						"otherInformation:"string"
			}`
		};
let allPrompts={extr:`Kindly extract contact information from the attached file. Use the 
                      specified schema for the naming of the JSON attributes. Extract a maximum
					  of three phone numbers named a phoneNo, mobilePhoneNo and officePhoneNo.

                       Return a JSON object of the contact data`
			};
				

let schema=allSchema[p_appEntKey];
let promptText=allPrompts[p_appEntKey];


let systemInput =  `
					You are a data extraction engine.

				IMPORTANT RULES:
				- Normalize dates to MM/DD/YYYY.
				- Output ONLY valid JSON matching the provided schema.
				`;
 


console.log('About calling AI');

   const payload = {systemInput:systemInput,prompt:promptText, schema:schema};

 // Build FormData
    const formData = new FormData();

    // Append JSON payload as a string
    formData.append("payload", JSON.stringify(payload));

    // Append the file
    formData.append("resume",p_file);
	

fn_AIProcessFile(formData)
  .then(resp => {return resp;})
  .catch(err => {
    console.error(err);
    this.d_loading = false;
    return `Error:err`;
  });
}